import Notes from "components/common/Notes";
import PremiumDeductiblesDialog from "components/inputs/ingestion/PremiumDeductibles/PremiumDeductiblesDialog";
import PremDeductDownloader from "components/inputs/premDeduct/PremDeductDownloader";
import { connect } from "react-redux";
import * as premDeductActions from "store/actions/input/exposure/premDeductActions";
import * as selectors from "store/selectors/input/exposure/premDeductSelectors";

export const PremDeductComponent = ({ note, updateNote }) => {
  return (
    <>
      <PremiumDeductiblesDialog />
      <PremDeductDownloader />
      <Notes md_width={12} lg_width={6} update={updateNote} value={note} />
    </>
  );
};

const mapDispatchToProps = {
  updateNote: premDeductActions.updatePremDeductNote,
};

const mapStateToProps = (state) => ({
  files: selectors.files(state),
  note: selectors.note(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremDeductComponent);
